<div fxLayout="column" fxHide.lt-md>
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else paymentAutomaticNoteListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="paymentAutomaticNoteListFlexColumnTemplate"></ng-container>
  </div>
</div>

<div fxLayout="column" fxHide.gt-sm ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <ng-container *ngTemplateOutlet="paymentAutomaticNoteListCardViewTemplate"></ng-container>
</div>

<ng-template #paymentAutomaticNoteListCardViewTemplate>
    <div fxLayout="column">
        <!-- Filter Control -->
        <mat-form-field *ngIf="autoPayNotesList.length > 5" appearance="fill" style="width: 100%;">
            <mat-label>Filter by Note Status</mat-label>
            <mat-select [(ngModel)]="selectedNoteStatus" (selectionChange)="filterNotes()">
                <mat-option *ngFor="let status of uniqueNoteStatuses" [value]="status">
                    {{ status }}
                </mat-option>
                <mat-option [value]="''">All</mat-option>
            </mat-select>
        </mat-form-field>
        <ng-container *ngFor="let row of filteredNotesList">
            <mat-card *ngIf="row.noteId">
                <mat-card-content>
                    <div style="width: 100%;">
                        <!-- Left Section: Note ID and Note Status -->
                        <div>
                            <mat-card-title>{{ row.noteId }}</mat-card-title>
                            <mat-card-subtitle>{{ row.noteStatus }}
                                <a class="tooltip-link" (click)="openToolTip('noteStatus')">
                                    <mat-icon
                                    class="tooltip-icon-link"
                                    matTooltip="{{ getToolTip('noteStatus') }}"
                                    matTooltipPosition="after"
                                    matTooltipClass="tooltip-multi-line"
                                    >help_outline</mat-icon
                                    >
                                </a>
                            </mat-card-subtitle>
                            <div style="display: flex; justify-content: space-between;">
                                <mat-label><span
                                        class="header-superscript header-after-content-3" *ngIf="CompanyCode_Check()"
                                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                        i18n="@@payment-automatic-note-list.table.column-header.next-payment-due-date"
                                        >payment-automatic-note-list.table.column-header.next-payment-due-date</span
                                    ></mat-label>
                                <span style="text-align: right;">{{ row.nextPaymentDueDate }}</span>
                            </div>
                            <div style="display: flex; justify-content: space-between;">
                                <mat-label>
                                        <span
                                            class="header-superscript header-after-content-2"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-automatic-note-list.table.column-header.total-amount-due"
                                            >payment-automatic-note-list.table.column-header.total-amount-due</span
                                        >
                                </mat-label>
                                <span style="text-align: right;">{{ row.totalAmountDue | currency }}</span>
                            </div>
                            <div style="display: flex; justify-content: space-between;">
                                <mat-label>
                                    <span
                                        class="header-superscript header-after-content-1"
                                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                        i18n="@@payment-automatic-note-list.table.column-header.payoff-amount"
                                        >payment-automatic-note-list.table.column-header.payoff-amount</span>
                                </mat-label>
                                <span style="text-align: right;">{{ row.payoffAmount | currency }}</span>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions style="display: flex; justify-content: right; align-items: right;">
                    <span [ngClass]="{ 'mat-column-options-ie': isBrowserIE }">
                        <button
                          mat-flat-button
                          color="primary"
                          (click)="selectNote(row.noteId, autoPaymentActionType.Setup)"
                          *ngIf="row.autoPayStatus.toUpperCase() === 'SETUP'"
                          i18n-matTooltip="@@payment-automatic-note-list.table.column.options.setup-button.tool-tip"
                          matTooltip="payment-automatic-note-list.table.column.options.setup-button.tool-tip"
                          i18n="@@payment-automatic-note-list.table.column.options.setup-button.label"
                        >
                          payment-automatic-note-list.table.column.options.setup-button.label
                        </button>
                        <button
                          mat-stroked-button
                          color="warn"
                          ngStyle.gt-sm="width: 100px;"
                          ngStyle.gt-md="width: 110px;"
                          (click)="selectNote(row.noteId, autoPaymentActionType.Cancel)"
                          *ngIf="row.autoPayStatus.toUpperCase() === 'CANCEL'"
                          i18n-matTooltip="@@payment-automatic-note-list.table.column.options.cancel-button.tool-tip"
                          matTooltip="payment-automatic-note-list.table.column.options.cancel-button.tool-tip"
                          i18n="@@payment-automatic-note-list.table.column.options.cancel-button.label"
                        >
                          payment-automatic-note-list.table.column.options.cancel-button.label
                        </button>
                        <button
                          mat-stroked-button
                          color="accent"
                          fxHide.lt-md
                          ngStyle.gt-sm="width: 100px;"
                          ngStyle.gt-md="width: 110px;"
                          (click)="selectNote(row.noteId, autoPaymentActionType.Ineligible)"
                          *ngIf="row.autoPayStatus.toUpperCase() === 'INELIGIBLE'"
                          i18n-matTooltip="@@payment-automatic-note-list.table.column.options.ineligible-button.tool-tip"
                          matTooltip="payment-automatic-note-list.table.column.options.ineligible-button.tool-tip"
                        >
                          <span i18n="@@payment-automatic-note-list.table.column.options.ineligible-button.label"
                            >payment-automatic-note-list.table.column.options.ineligible-button.label</span
                          >
                          <mat-icon class="tooltip-icon-button">help_outline</mat-icon>
                        </button>
                        <a
                          class="button-link"
                          fxHide.gt-sm
                          (click)="selectNote(row.noteId, autoPaymentActionType.Ineligible)"
                          *ngIf="row.autoPayStatus.toUpperCase() === 'INELIGIBLE'"
                          i18n-matTooltip="@@payment-automatic-note-list.table.column.options.ineligible-anchor.tool-tip"
                          matTooltip="payment-automatic-note-list.table.column.options.ineligible-anchor.tool-tip"
                          i18n="@@payment-automatic-note-list.table.column.options.ineligible-anchor.label"
                          >payment-automatic-note-list.table.column.options.ineligible-anchor.label</a
                        >
                      </span>
                </mat-card-actions>
            </mat-card>
        </ng-container>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="autoPayNotesListFound && displayNotices">
      <div *ngIf="isBrowserIE; else paymentAutomaticNoteListNoticesFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentAutomaticNoteListNoticesFlexColumnTemplate"></ng-container>
      </div>
    </div>
</ng-template>

<ng-template #paymentAutomaticNoteListFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
      <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxLayout="column" *ngIf="!showSpinner">
      <div *ngIf="isBrowserIE; else paymentAutomaticNoteListTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentAutomaticNoteListTableFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #paymentAutomaticNoteListTableFlexColumnTemplate>
  <div fxFlex="100%" class="display-text primary-dark-color-important" *ngIf="displayTitle">
    <b><span i18n="@@payment-automatic-note-list.table.title">payment-automatic-note-list.table.title</span></b>
  </div>

  <div fxFlex="100%" class="display-text title-spacer" *ngIf="!autoPayNotesListFound">
    <i><span i18n="@@payment-automatic-note-list.table.no-records">payment-automatic-note-list.table.no-records</span></i>
  </div>

  <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
    <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
      <!-- noteId Column -->
      <ng-container matColumnDef="noteId">
        <mat-header-cell *matHeaderCellDef fxFlex="12%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@payment-automatic-note-list.table.column-header.note-id"
            >payment-automatic-note-list.table.column-header.note-id</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.noteId
        }}</mat-cell>
      </ng-container>
      <!-- noteStatus Column -->
      <ng-container matColumnDef="noteStatus">
        <mat-header-cell *matHeaderCellDef fxFlex="16%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@payment-automatic-note-list.table.column-header.note-status"
            >payment-automatic-note-list.table.column-header.note-status</span
          >
          <a class="tooltip-link" (click)="openToolTip('noteStatus')">
            <mat-icon
              class="tooltip-icon-link"
              matTooltip="{{ getToolTip('noteStatus') }}"
              matTooltipPosition="after"
              matTooltipClass="tooltip-multi-line"
              >help_outline</mat-icon
            >
          </a>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="16%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.noteStatus
        }}</mat-cell>
      </ng-container>
      <!-- nextPaymentDueDate Column -->
      <ng-container matColumnDef="nextPaymentDueDate">
        <mat-header-cell *matHeaderCellDef fxFlex="12%">
          <span
            class="header-superscript header-after-content-3" *ngIf="CompanyCode_Check()"
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@payment-automatic-note-list.table.column-header.next-payment-due-date"
            >payment-automatic-note-list.table.column-header.next-payment-due-date</span
          >
          <span
            *ngIf="!CompanyCode_Check()"
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@payment-automatic-note-list.table.column-header.next-payment-due-date"
            >payment-automatic-note-list.table.column-header.next-payment-due-date</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.nextPaymentDueDate
        }}</mat-cell>
      </ng-container>
      <!-- lastPaymentDate Column -->
      <ng-container matColumnDef="lastPaymentDate">
        <mat-header-cell *matHeaderCellDef fxFlex="12%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@payment-automatic-note-list.table.column-header.last-payment-date"
            >payment-automatic-note-list.table.column-header.last-payment-date</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.lastPaymentDate | date: 'MM/dd/yyyy'
        }}</mat-cell>
      </ng-container>
      <!-- lastPaymentAmount Column -->
      <ng-container matColumnDef="lastPaymentAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="12%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@payment-automatic-note-list.table.column-header.last-payment-amount"
            >payment-automatic-note-list.table.column-header.last-payment-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.lastPaymentAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- totalAmountDue Column -->
      <ng-container matColumnDef="totalAmountDue">
        <mat-header-cell *matHeaderCellDef fxFlex="12%">
          <span
            class="header-superscript header-after-content-2"
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@payment-automatic-note-list.table.column-header.total-amount-due"
            >payment-automatic-note-list.table.column-header.total-amount-due</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.totalAmountDue | currency
        }}</mat-cell>
      </ng-container>
      <!-- payoffAmount Column -->
      <ng-container matColumnDef="payoffAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="12%">
          <span
            class="header-superscript header-after-content-1"
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@payment-automatic-note-list.table.column-header.payoff-amount"
            >payment-automatic-note-list.table.column-header.payoff-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.payoffAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- options Column -->
      <ng-container matColumnDef="options">
        <mat-header-cell *matHeaderCellDef fxFlex="12%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@payment-automatic-note-list.table.column-header.options"
            >payment-automatic-note-list.table.column-header.options</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="12%" class="mat-column-data-centered" ngClass.lt-md="small-table-text">
          <span [ngClass]="{ 'mat-column-options-ie': isBrowserIE }">
            <button
              mat-flat-button
              color="primary"
              fxHide.lt-md
              ngStyle.gt-sm="width: 100px;"
              ngStyle.gt-md="width: 110px;"
              (click)="selectNote(row.noteId, autoPaymentActionType.Setup)"
              *ngIf="row.autoPayStatus.toUpperCase() === 'SETUP'"
              i18n-matTooltip="@@payment-automatic-note-list.table.column.options.setup-button.tool-tip"
              matTooltip="payment-automatic-note-list.table.column.options.setup-button.tool-tip"
              i18n="@@payment-automatic-note-list.table.column.options.setup-button.label"
            >
              payment-automatic-note-list.table.column.options.setup-button.label
            </button>
            <a
              class="button-link"
              fxHide.gt-sm
              (click)="selectNote(row.noteId, autoPaymentActionType.Setup)"
              *ngIf="row.autoPayStatus.toUpperCase() === 'SETUP'"
              i18n-matTooltip="@@payment-automatic-note-list.table.column.options.setup-anchor.tool-tip"
              matTooltip="payment-automatic-note-list.table.column.options.setup-anchor.tool-tip"
              i18n="@@payment-automatic-note-list.table.column.options.setup-anchor.label"
              >payment-automatic-note-list.table.column.options.setup-anchor.label</a
            >
            <button
              mat-stroked-button
              color="warn"
              fxHide.lt-md
              ngStyle.gt-sm="width: 100px;"
              ngStyle.gt-md="width: 110px;"
              (click)="selectNote(row.noteId, autoPaymentActionType.Cancel)"
              *ngIf="row.autoPayStatus.toUpperCase() === 'CANCEL'"
              i18n-matTooltip="@@payment-automatic-note-list.table.column.options.cancel-button.tool-tip"
              matTooltip="payment-automatic-note-list.table.column.options.cancel-button.tool-tip"
              i18n="@@payment-automatic-note-list.table.column.options.cancel-button.label"
            >
              payment-automatic-note-list.table.column.options.cancel-button.label
            </button>
            <a
              class="button-link"
              fxHide.gt-sm
              (click)="selectNote(row.noteId, autoPaymentActionType.Cancel)"
              *ngIf="row.autoPayStatus.toUpperCase() === 'CANCEL'"
              i18n-matTooltip="@@payment-automatic-note-list.table.column.options.cancel-anchor.tool-tip"
              matTooltip="payment-automatic-note-list.table.column.options.cancel-anchor.tool-tip"
              i18n="@@payment-automatic-note-list.table.column.options.cancel-anchor.label"
              >payment-automatic-note-list.table.column.options.cancel-anchor.label</a
            >
            <button
              mat-stroked-button
              color="accent"
              fxHide.lt-md
              ngStyle.gt-sm="width: 100px;"
              ngStyle.gt-md="width: 110px;"
              (click)="selectNote(row.noteId, autoPaymentActionType.Ineligible)"
              *ngIf="row.autoPayStatus.toUpperCase() === 'INELIGIBLE'"
              i18n-matTooltip="@@payment-automatic-note-list.table.column.options.ineligible-button.tool-tip"
              matTooltip="payment-automatic-note-list.table.column.options.ineligible-button.tool-tip"
            >
              <span i18n="@@payment-automatic-note-list.table.column.options.ineligible-button.label"
                >payment-automatic-note-list.table.column.options.ineligible-button.label</span
              >
              <mat-icon class="tooltip-icon-button">help_outline</mat-icon>
            </button>
            <a
              class="button-link"
              fxHide.gt-sm
              (click)="selectNote(row.noteId, autoPaymentActionType.Ineligible)"
              *ngIf="row.autoPayStatus.toUpperCase() === 'INELIGIBLE'"
              i18n-matTooltip="@@payment-automatic-note-list.table.column.options.ineligible-anchor.tool-tip"
              matTooltip="payment-automatic-note-list.table.column.options.ineligible-anchor.tool-tip"
              i18n="@@payment-automatic-note-list.table.column.options.ineligible-anchor.label"
              >payment-automatic-note-list.table.column.options.ineligible-anchor.label</a
            >
          </span>
        </mat-cell>
      </ng-container>
      <mat-header-row
        class="primary-light-bg-top-to-bottom-gradient"
        *matHeaderRowDef="tableDisplayedColumns"
        ngClass.lt-md="small-header-row"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: tableDisplayedColumns"
        ngClass.lt-md="small-row"
        [ngClass]="{ 'primary-lightest-bg': row.noteId === selectedNoteId }"
      ></mat-row>
    </mat-table>

    <div fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="autoPayNotesListFound">
      <app-table-record-count
        [recordCount]="autoPayNotesList.length"
        i18n-singularLabel="@@payment-automatic-note-list.table.record-count.singular-label"
        singularLabel="payment-automatic-note-list.table.record-count.singular-label"
        i18n-multipleLabel="@@payment-automatic-note-list.table.record-count.multiple-label"
        multipleLabel="payment-automatic-note-list.table.record-count.multiple-label"
      ></app-table-record-count>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="autoPayNotesListFound && displayNotices">
      <div *ngIf="isBrowserIE; else paymentAutomaticNoteListNoticesFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentAutomaticNoteListNoticesFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #paymentAutomaticNoteListNoticesFlexColumnTemplate>
  <div fxFlex="100%" class="display-text">
    <sup>1</sup>&nbsp;<span i18n="@@payment-automatic-note-list.notices.1a">payment-automatic-note-list.notices.1a</span>&nbsp;<b
      ><span i18n="@@payment-automatic-note-list.notices.1b">payment-automatic-note-list.notices.1b</span></b
    >&nbsp;<span i18n="@@payment-automatic-note-list.notices.1c">payment-automatic-note-list.notices.1c</span>
  </div>
  <div fxFlex="100%" class="display-text">
    <sup>2</sup>&nbsp;<span i18n="@@payment-automatic-note-list.notices.2">payment-automatic-note-list.notices.2</span>
  </div>
  <div fxFlex="100%" class="display-text" *ngIf="CompanyCode_Check()">
    <sup>3</sup>&nbsp;<b><span i18n="@@payment-automatic-note-list.notices.3a">payment-automatic-note-list.notices.3a</span>&nbsp;
        <a target="_blank" href="https://www.tuitionoptions.com/about-payments">
        <span i18n="@@payment-automatic-note-list.notices.3b">payment-automatic-note-list.notices.3b</span>
      </a>&nbsp;
      <span i18n="@@payment-automatic-note-list.notices.3c">payment-automatic-note-list.notices.3c</span>
      </b>
  </div>
</ng-template>
